import React from 'react';
import { DropdownComposite as DropdownCompositeNew } from './DropdownComposite';
import { convertOldDropdownCompositeProps } from './converter.old';
import type { OldDropdownCompositeProps } from './converter.old';

export type DropdownCompositeProps<OptionValue> = OldDropdownCompositeProps<OptionValue>;

export const DropdownComposite = <OptionValue,>(props: DropdownCompositeProps<OptionValue>) => (
  <DropdownCompositeNew {...convertOldDropdownCompositeProps(props)} />
);
